import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  height: 24px;

  .logo {
    height: 100%;
  }

  @media(${breakpoint.lgMin}) {
    height: 32px;
  }

  & > div:first-child {
    height: 100%;
    width: fit-content;

    img {
      width: auto;
      height: 100%;
    }
  }
`;

export const Placeholder = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${font.graphikCond};
  width: 124px;
  height: 24px;
  background: ${getColor('surfaceTertiary')};
  color: ${getColor('textPrimary')};
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  
  @media(${breakpoint.lgMin}) {
    width: 160px;
    height: 32px;
  }
`;

export default Wrapper;
